export enum LogExecutionResult {
    Pending = 1,
    EvaFailed = 2,
    AcceptedNoConfirmation = 3,
    Confirmed = 4,
    Timeout = 5,
    Offline = 6,
    Nack = 7,
    Aborted = 8
}

export function getLogExecutionResultString(logExecutionResult: LogExecutionResult | null | undefined): string {
    switch (logExecutionResult) {
        case LogExecutionResult.Pending:
            return 'Schaltung läuft';
        case LogExecutionResult.EvaFailed:
            return 'Von Station abgelehnt';
        case LogExecutionResult.AcceptedNoConfirmation:
            return 'Gesendet (ohne Bestätigung)';
        case LogExecutionResult.Confirmed:
            return 'Bestätigt';
        case LogExecutionResult.Timeout:
            return 'Keine Bestätigung';
        case LogExecutionResult.Offline:
            return 'Station offline';
        case LogExecutionResult.Nack:
            return 'Negative Quittung';
        case LogExecutionResult.Aborted:
            return 'Abgebrochen';
        default:
            return '';
    }
}
